var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 154.6 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--calendar",
    x1: 3.65,
    y1: 877.56,
    x2: 28.49,
    y2: 902.4,
    gradientTransform: "translate(0 -874)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd4e39"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.7,19.1c-.5-.4-.9-.4-1.2.1l-.4.3a4.3,4.3,0,0,1-3.2,1.6,4.6,4.6,0,0,1-4.5-4.8A4.8,4.8,0,0,1,48,11.5a4.1,4.1,0,0,1,3.1,1.6.8.8,0,0,0,1.2.1l1.2-1.1c.5-.3.5-.8.1-1.3A6.8,6.8,0,0,0,47.9,8a8.3,8.3,0,0,0-8.2,8.3,8.1,8.1,0,0,0,8.2,8.3,7.4,7.4,0,0,0,6.2-3.3c.2-.3.4-.7-.4-1.3Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,7.9a17.9,17.9,0,0,0-5.4.9.8.8,0,0,0-.6,1l.4,1.4a.8.8,0,0,0,1,.7,14.3,14.3,0,0,1,4.4-.7,2,2,0,0,1,1.6.6c.5.4.6,1.3.6,2.6a13,13,0,0,0-3-.5c-3.8,0-6.3,2-6.3,5.2s2,5.3,5.1,5.3a6.7,6.7,0,0,0,4.7-1.8l.4.9a.7.7,0,0,0,.7.6h1.1a1,1,0,0,0,.8-.9V15C68.1,11,67.7,7.9,62.6,7.9ZM61,21.4a2,2,0,0,1-2.2-2.2c0-1.5,1.2-2.4,3.1-2.4a5.4,5.4,0,0,1,2.6.5v2.4A4.9,4.9,0,0,1,61,21.4Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,1.1H72a1,1,0,0,0-.8.8V23.2a1,1,0,0,0,.8.9h2a1,1,0,0,0,.8-.9V1.9A1,1,0,0,0,74,1.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,7.9c-4.6,0-7.9,3.6-7.9,8.3s3.3,8.2,7.9,8.2a9,9,0,0,0,5.8-1.9c.6-.5.4-.8.2-1.2l-1-1.5c-.1-.3-.2-.4-.5-.4a1.1,1.1,0,0,0-.7.3A6.4,6.4,0,0,1,85.1,21a4.7,4.7,0,0,1-4.6-4H91.1a.9.9,0,0,0,.8-.8c0-.3.1-.9.1-1.1A6.8,6.8,0,0,0,85,7.9ZM84.9,11a3.6,3.6,0,0,1,3.7,3.3H80.9A3.7,3.7,0,0,1,84.9,11Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,7.9A7.1,7.1,0,0,0,97.2,10l-.4-1.1a.7.7,0,0,0-.7-.6h-.8a1,1,0,0,0-.9.8v14a1,1,0,0,0,.9.9h1.6c.8,0,1.1-.4,1.1-.9V13.5a4.7,4.7,0,0,1,4-2.1c1.9,0,2.8,1.3,2.8,3.8v7.9a1,1,0,0,0,.9.9h1.9a.9.9,0,0,0,.8-.9V15.2C108.4,10.3,106.4,7.9,102.3,7.9Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7,1.1h-1.9a.9.9,0,0,0-.8.8V8.6h0a12.1,12.1,0,0,0-3.8-.7c-4.4,0-7.6,3.6-7.6,8.3s3.2,8.2,7.2,8.2a7.8,7.8,0,0,0,5-2l.2.8c.2.5.5.8.9.8h.8a.9.9,0,0,0,.8-.9V1.9C125.7,1.5,125.2,1.1,124.7,1.1ZM118.2,21c-2.2,0-4-2.1-4-4.8a4.5,4.5,0,0,1,4.4-4.8,7.4,7.4,0,0,1,3.4.8v6.6A4.5,4.5,0,0,1,118.2,21Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,7.9a17.9,17.9,0,0,0-5.4.9.8.8,0,0,0-.6,1l.4,1.4a.9.9,0,0,0,1.1.7,13,13,0,0,1,4.3-.7,2,2,0,0,1,1.6.6c.5.4.6,1.3.6,2.6a11.1,11.1,0,0,0-3-.5c-3.8,0-6.3,2-6.3,5.2s2,5.3,5.1,5.3a6.7,6.7,0,0,0,4.7-1.8l.4.9a.7.7,0,0,0,.7.6h1.1a1,1,0,0,0,.8-.9V15C140.6,11,140.1,7.9,135,7.9Zm-1.4,13.5a2,2,0,0,1-2.3-2.2c0-1.5,1.2-2.4,3.1-2.4a5.4,5.4,0,0,1,2.6.5v2.4A4.6,4.6,0,0,1,133.6,21.4Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,8.8c-.3-.6-1.9-.9-3-.9a5.6,5.6,0,0,0-4.6,2.2L146,9a.8.8,0,0,0-.8-.6h-.9a1,1,0,0,0-.8.8v14a1,1,0,0,0,.8.9h1.6c.5,0,1.2,0,1.2-.9V13.4a3.9,3.9,0,0,1,3.5-1.9c.4,0,1.2.1,1.3.3h.6l.5-.5.8-1.7C154.3,9.2,154.2,9,154,8.8Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1.5C3.6.5.5,3.6.5,15.9S3.6,31.5,16.1,31.5s15.5-3.1,15.5-15.6S28.4.5,16.1.5Z",
    fill: "url(#linear-gradient--calendar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,10.6H21.1V9.5a.9.9,0,0,0-.9-.9h-.4a.9.9,0,0,0-.9.9v1.1h-6V9.5a.8.8,0,0,0-.8-.9h-.3a.9.9,0,0,0-.9.9v1.1H9.6a1,1,0,0,0-1,.9v11a1.1,1.1,0,0,0,1,1h13a1.1,1.1,0,0,0,1-1v-11A1.1,1.1,0,0,0,22.5,10.6ZM21.1,21H10.9V14.5H21.1Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBadgeColor);
export default __webpack_public_path__ + "static/media/calendar-badge-color.747acc35117374de7319db6e9b281406.svg";
export { ForwardRef as ReactComponent };